import React, { useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BellRing, Mail } from "lucide-react";
import { toast } from "sonner";

const PLANNER = ["public_authority", "collective_executive", "admin"];

export const TailingsAlerts = ({ site, onChanged }) => {
  const { user } = useAuth();
  const [emails, setEmails] = useState((site.alert_emails || []).join(", "));
  const [busy, setBusy] = useState(false);
  const a = site.last_alert;
  const planner = user && PLANNER.includes(user.role);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.patch(`/mining/sites/${site.id}/alerts`, { alert_emails: emails.split(/[,\s]+/).filter(Boolean) }); toast.success(`Alert list saved · ${data.planners_notified.length} recipient(s) on escalation`); onChanged?.(); }
    catch (e) { toast.error(apiErr(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2" data-testid="tailings-alerts">
      {a && (
        <div className="border p-3 text-xs flex items-start gap-2" style={{ borderColor: (a.to_level === "critical" ? "#EF4444" : "#F97316") + "88", background: (a.to_level === "critical" ? "#EF4444" : "#F97316") + "0d" }} data-testid="tailings-alert-banner">
          <BellRing className="h-4 w-4 shrink-0" style={{ color: a.to_level === "critical" ? "#EF4444" : "#F97316" }} />
          <div><div className="font-semibold text-slate-100">Tailings alert sent · survey v{a.survey_version} · {a.from_level || "unsurveyed"} → <span className="uppercase">{a.to_level}</span> · AMD {a.acid_drainage_risk}</div>
            <div className="text-slate-400">{a.at.slice(0, 16)} UTC · {a.delivered}/{a.recipients.length} email(s) delivered{a.recipients.some((r) => r.status === "failed") ? ` · ${a.recipients.filter((r) => r.status === "failed").map((r) => r.email.split("@")[0]).join(", ")} undeliverable` : ""} · anchor {a.anchor.slice(0, 14)}…</div></div>
        </div>
      )}
      {planner && (
        <div className="flex flex-wrap items-center gap-2 text-xs" data-testid="alert-emails-form">
          <Mail className="h-3.5 w-3.5 text-slate-500" /><span className="text-slate-500">Extra alert emails (planners are always notified)</span>
          <input data-testid="alert-emails-input" className="bg-[#050A15] border border-white/10 px-2 py-1 flex-1 min-w-[220px]" placeholder="planner@municipality.gov.tr, ngo@example.org" value={emails} onChange={(e) => setEmails(e.target.value)} />
          <button data-testid="alert-emails-save" disabled={busy} onClick={save} className="qs-cta bg-[#8A2BE2] text-white px-3 py-1">save</button>
        </div>
      )}
    </div>
  );
};
